'use strict';Object.defineProperty(exports,'__esModule',{value:!0});var createEvent=function(type,_ref){var bubbles=_ref.bubbles,cancelable=_ref.cancelable,event=void 0;return'function'==typeof Event?event=new Event(type,{bubbles:bubbles,cancelable:cancelable}):(event=document.createEvent('Event'),event.initEvent(type,bubbles,cancelable)),event};exports.default=createEvent;


/** WEBPACK FOOTER **
 ** ./~/@vitalsource/vstui/utils/createEvent.js
 **/